<template>
  <div>
    Display View Fields Here...
  </div>
</template>

<script>
export default {
  name: 'ViewFields',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
